import AbstractPolicy from "@/policies/Proposal/Product/ProductPolicy/AbstractPolicy";
import Product from "@/models/Proposal/Product/Product";

export default class ApiNotifyPolicy extends AbstractPolicy {

    static updatePurchasePrices(user, product) {
        const productData = Product.query().with(['upsell']).find(product.id);

        if (productData.proposal_cancellation_id || productData.upsell) {
            return false;
        }

        return user.HasPermission('customers.dossiers.proposals.write');
    }

}
